// action - state management
import { LOGIN, LOGOUT, REGISTER, SET_SELECTED_HOTEL } from './actions';
import { InitialLoginContextProps } from 'types/auth';

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
  type: string;
  payload?: Partial<InitialLoginContextProps> & { selectedHotelId?: number | null };
}

const initialState: InitialLoginContextProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  selectedHotelId: null
};

export default function accountReducer(state = initialState, action: AccountReducerActionProps) {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user, selectedHotelId } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        selectedHotelId: selectedHotelId ?? state.selectedHotelId ?? null
      };
    }
    case SET_SELECTED_HOTEL: {
      return {
        ...state,
        selectedHotelId: action.payload?.selectedHotelId ?? null
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        selectedHotelId: null
      };
    }
    default: {
      return { ...state };
    }
  }
}
